var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { BorderRadius, Colors, InlineChildren, Inset, StackChildren, Text, } from '@doordash/design-language';
import styled from 'styled-components';
import OptInStrings from '../OptIn/OptInStrings';
import { EmailField } from '@doordash/component-fields';
import Button from '@doordash/component-button';
import { isEmailFormatValid } from '../../utils/validateEmailHelper';
import { KEY_CODES } from '../../constants/values';
import track from '../../utils/track';
import { JoinV2PageEvents } from '../../constants/events/names';
var ResendInviteInputContainer = styled(Inset)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 90%;\n  max-width: 640px;\n  border-radius: ", "px;\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);\n  background-color: ", ";\n"], ["\n  width: 90%;\n  max-width: 640px;\n  border-radius: ", "px;\n  box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.2);\n  background-color: ", ";\n"])), BorderRadius.Large, Colors.BackgroundPrimary);
var ResendInviteInput = function (_a) {
    var isMobile = _a.isMobile, isLoading = _a.isLoading, onOpenInviteResentModal = _a.onOpenInviteResentModal, onResendInvite = _a.onResendInvite;
    var _b = __read(React.useState(''), 2), email = _b[0], setEmail = _b[1];
    var _c = __read(React.useState(''), 2), error = _c[0], setError = _c[1];
    var handleEmailChange = function (newEmail) {
        setError('');
        setEmail(newEmail);
    };
    var onResendInviteClick = React.useCallback(function () {
        if (!email) {
            setError(OptInStrings.enrollErrors.fieldIsRequired());
            return;
        }
        var isEmailValid = isEmailFormatValid(email);
        if (!isEmailValid) {
            setError(OptInStrings.enrollErrors.enterValidEmail());
            return;
        }
        setError('');
        // ensure email submission is in lowercase
        onResendInvite({
            emails: [email.toLowerCase()],
            isGuest: true,
        }, {
            onCompleted: function (result) {
                var _a, _b, _c, _d, _e;
                if ((_a = result === null || result === void 0 ? void 0 : result.sendJoinInvitationEmailToSelectedPendingTeamMembers) === null || _a === void 0 ? void 0 : _a.successes) {
                    track(JoinV2PageEvents.WORK_PORTAL_JOIN_PAGE_V2_LANDING_PAGE_RESEND_INVITE_SUCCESS);
                }
                if ((_b = result === null || result === void 0 ? void 0 : result.sendJoinInvitationEmailToSelectedPendingTeamMembers) === null || _b === void 0 ? void 0 : _b.failures) {
                    track(JoinV2PageEvents.WORK_PORTAL_JOIN_PAGE_V2_LANDING_PAGE_RESEND_INVITE_ERROR, {
                        error_type: (_e = (_d = (_c = result === null || result === void 0 ? void 0 : result.sendJoinInvitationEmailToSelectedPendingTeamMembers) === null || _c === void 0 ? void 0 : _c.failures[0]) === null || _d === void 0 ? void 0 : _d.error) === null || _e === void 0 ? void 0 : _e.errorCode,
                    });
                }
                // Open modal to show an generic success message that resend invite was triggered
                // hiding success/error details from users intentionally for security reasons
                onOpenInviteResentModal();
            },
        });
    }, [email, onResendInvite, onOpenInviteResentModal]);
    // submit email on enter
    var onEmailInputKeydown = React.useCallback(function (e) {
        if (e.keyCode === KEY_CODES.ENTER) {
            onResendInviteClick();
        }
    }, [onResendInviteClick]);
    // Display side-by-side on desktop, and top-bottom on mobile
    var InputEmailLineWrapper = isMobile ? StackChildren : InlineChildren;
    return (React.createElement(ResendInviteInputContainer, null,
        React.createElement(StackChildren, null,
            React.createElement(Text, { color: Text.Colors.TextPrimary, styles: Text.Styles.Label1Emphasis }, OptInStrings.enterWorkEmailAddress()),
            React.createElement(InputEmailLineWrapper, null,
                React.createElement(EmailField, { label: "Email", isLabelHidden: true, placeholder: OptInStrings.workEmailAddressPlaceholder(), value: email, onChange: handleEmailChange, onKeyDown: onEmailInputKeydown, error: error, isDisabled: isLoading, autoFocus: true }),
                React.createElement("div", null,
                    React.createElement(Button, { isInline: true, state: isLoading ? Button.States.Loading : Button.States.Default, onClick: onResendInviteClick }, OptInStrings.enroll()))))));
};
export default ResendInviteInput;
var templateObject_1;
